import React from 'react';
import PropTypes from 'prop-types';
import InformationIcon from 'zignal-landscape/lib/Icon/InformationIcon';

import { AUTOMATION_COLORS } from '../../constants';
import themeable from 'zignal-landscape/lib/themeable';
import Card from 'zignal-landscape/lib/Card';
import ToolTip from 'zignal-landscape/lib/ToolTip';

const GraphLegend = ({styles}) => {
  const tooltipText = `
The automation score highlights when an author is exhibiting automated behavior based on the account's posting patterns.
The higher the value, the more likely the author is exhibiting automated behaviors.
  `;
  return (
    <div className={styles.GraphLegend}>
      <Card>
        <div className={styles.legendContainer}>
          <div className={styles.text}>
            <span className={styles.topText}>Automation Score</span>
            <ToolTip
              position="top"
              tooltipText={<div className={styles.toolTip}>{tooltipText}</div>}
            >
              <span><InformationIcon /></span>
            </ToolTip>
          </div>
          <div className={styles.gradientContainer}>
            <div className={styles.gradients}>
              {AUTOMATION_COLORS.map((backgroundColor) => {
                return <div key={backgroundColor} className={styles.gradient} style={{backgroundColor}} />;
              })}
            </div>
          </div>
          <div className={styles.text}>
            <div className={styles.bottomText}>
              <span>Low</span>
              <span>Med</span>
              <span>High</span>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

GraphLegend.propTypes = {
  styles: PropTypes.object.isRequired
};

export default themeable(GraphLegend);
